// src/store.js
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import generalReducer from "./features/general.js";
import authReducer from "./features/auth.js";
import tableSlice from "./features/table.js";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Defaults to localStorage for web

// Configuring persist for auth slice only
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"], // Only persist the auth slice
};

// Combine reducers
const rootReducer = combineReducers({
  auth: authReducer,
  general: generalReducer,
  table: tableSlice,
});

// Wrap rootReducer with persistReducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure the store
const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);
export default store;
